import React from "react";
import ProcessingBar2 from "../../ProcessingBar/ProcessingBar2";

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-dry  p-6 rounded-lg shadow-lg w-[90%] max-w-md animate-fadeIn">
        <h2 className="text-lg font-semibold text-navy mb-3">
          Permanently Delete Items
        </h2>
        <hr className="border border-border w-12 my-3" />
        <p className="text-sm text-text mb-6">
          Are you sure you want to permanently delete this item? This action
          cannot be undone.
        </p>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-md text-sm text-text border border-border hover:text-white hover:bg-textGray "
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-md text-sm bg-navy text-yellowstar hover:bg-navylight min-w-[120px]"
            onClick={onConfirm}
          >
            {isLoading ? (
              <div className="ml-10">
                <ProcessingBar2 />
              </div>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
